

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import ResultSuccessTickMark from "../../shared/ResultSuccessTickMark"
import { getMektupData } from "../../../features/joblist/jobListSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        max-height: 700px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;


            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                text-align: center;
                line-height: 20px;
            }
        }
    }
`

const JobListBirebirEslestirResultModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {aracBekleyenYukCheckedItem, yukBekleyenAracCheckedItemList, lastJobListAssignmentMode} = useSelector(state => state.jobList)

    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            <ResultSuccessTickMark/>
            {lastJobListAssignmentMode === 1 ? (
                <p>Yük taşıma setine atandı. Mobil sürücünün taşıma setini teslim alması bekleniyor.</p>
            ) : (
                <p>Seçilen yük seçilen sürücüye atanmıştır. Artık <span style={{fontWeight: "bolder"}}>Yüklemede</span> adımından itibaren takip edebilirsiniz. Taşıma Senedi düzenleyerek sürücüyü yüklemeye gönderebilirsiniz.</p>
            )}
            <Btn
                width={"200px"}
                color="flex"
                handleClick={() => {
                    if (lastJobListAssignmentMode === 1) {
                        dispatch(showModal(null))
                        return
                    }
                    dispatch(showModal("showMektup"))
                    dispatch(getMektupData({yukData: aracBekleyenYukCheckedItem, aracData: yukBekleyenAracCheckedItemList[0]}))
                }}
            >Tamam</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default JobListBirebirEslestirResultModal
